import * as React from "react";

import { useProminentError } from "../../../Common";

export enum ContentRoutes {
  Details = "details",
  Success = "success",
}

export type ContentRoute = `${ContentRoutes}`;

interface ContentRouteConsumerInterface {
  selectedContentRoute: ContentRoute;

  onUserWantsToSelectContentRoute: (route: ContentRoute) => void;
}

const defaultValue = {
  selectedContentRoute: ContentRoutes.Details,
};

const ContentRouteContext = React.createContext(
  defaultValue as ContentRouteConsumerInterface
);

interface ContentRouteProviderProps {
  children?: React.ReactNode;
}

export const ContentRouteProvider: React.FunctionComponent<
  ContentRouteProviderProps
> = (props) => {
  const { setProminentError } = useProminentError();

  const [selectedContentRoute, setSelectedContentRoute] =
    React.useState<ContentRoute>(ContentRoutes.Details);

  const onUserWantsToSelectContentRoute = (route: ContentRoute) => {
    setProminentError(null);
    setSelectedContentRoute(route);
  };

  return (
    <ContentRouteContext.Provider
      value={{
        selectedContentRoute,

        onUserWantsToSelectContentRoute,
      }}
    >
      {props?.children}
    </ContentRouteContext.Provider>
  );
};

export const useContentRoute = () => {
  const context = React.useContext(ContentRouteContext);
  if (context === defaultValue) {
    throw new Error(
      "useContentRoute must be used within a <ContentRouteProvider>"
    );
  }
  return context;
};
